import {Pipe, PipeTransform} from '@angular/core';
import {Shipment} from '../domain/shipment';
import {Deviation} from '../domain/deviation';

@Pipe({
    name: 'deviationDescription',
    standalone: false
})
export class DeviationDescriptionPipe implements PipeTransform {
  transform(shipment: Shipment): string {
    if (shipment.DeviationCount != null) {
      if (shipment.DeviationCount > 1) {
        return shipment.DeviationCount + ' avvik';
      }

      if (shipment.DeviationCount === 1) {
        return shipment.LastDeviationName.NO != null ? shipment.LastDeviationName.NO : 'Ukjent avvik';
      }

      return 'Ingen avvik';
    }

    const deviations: Deviation[] = this.findAllDeviationsForShipment(shipment);

    if (deviations.length > 1) {
      return deviations.length + ' avvik';
    }

    if (deviations.length === 1) {
      return deviations[0].DefinitionName.NO;
    }
    return 'Ingen avvik';
  }

  private findAllDeviationsForShipment(shipment: Shipment) {
    const deviations: Deviation[] = [];

    deviations.push(...shipment.Deviations);

    shipment.Parcels.forEach((parcel) => deviations.push(...parcel.Deviations));

    return deviations;
  }
}
